import { render, staticRenderFns } from "./addWarehouse.vue?vue&type=template&id=4c11974c&scoped=true"
import script from "./addWarehouse.vue?vue&type=script&lang=js"
export * from "./addWarehouse.vue?vue&type=script&lang=js"
import style0 from "./addWarehouse.vue?vue&type=style&index=0&id=4c11974c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c11974c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c11974c')) {
      api.createRecord('4c11974c', component.options)
    } else {
      api.reload('4c11974c', component.options)
    }
    module.hot.accept("./addWarehouse.vue?vue&type=template&id=4c11974c&scoped=true", function () {
      api.rerender('4c11974c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/distribution/qty/addWarehouse.vue"
export default component.exports